import { render, staticRenderFns } from "./base-textarea.vue?vue&type=template&id=148c4b24&scoped=true&"
import script from "./base-textarea.vue?vue&type=script&lang=js&"
export * from "./base-textarea.vue?vue&type=script&lang=js&"
import style0 from "./base-textarea.vue?vue&type=style&index=0&id=148c4b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c4b24",
  null
  
)

export default component.exports